<div class="layout-wrapper layout-content-navbar" *ngIf="isAdmin">
    <div class="layout-container">

      <!-- Sidebar -->
       <aside #layoutMenu id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme ">
        <div class="app-brand demo my-3">
          <a routerLink="/Home">
            <img src="assets/img/logo.png" alt="Logo" style="width: auto;" height="50px" />
          </a>

         <a #menuToggle (click)="toggleMenu()" id="mobile-menu-btn" class="menu-link text-large ms-auto d-block d-xl-none">
              <i class="fa-solid fa-chevron-left fa-sm align-middle"></i>
        </a>
        </div>

        <div class="menu-inner-shadow"></div>

        <ul class="menu-inner py-1">

          <!-- Dashboard -->
          <li (click)="toggleMenu()" class="menu-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <a routerLink="/Admin/Dashboard" class="menu-link">
              <i class="menu-icon fa fa-tachometer-alt"></i>
              <div>Dashboard</div>
            </a>
          </li>

          <!-- Job Listings Management -->
          <li (click)="toggleMenu()" class="menu-item" routerLinkActive="active">
            <a routerLink="/Admin/JobList" class="menu-link">
              <i class="menu-icon fa fa-briefcase"></i>
              <div>Stellenangebote</div>
            </a>
          </li>

          <!-- User Management -->
          <li (click)="toggleMenu()" class="menu-item" routerLinkActive="active">
            <a routerLink="/Admin/UserList" class="menu-link">
              <i class="menu-icon fa fa-users"></i>
              <div>Benutzer</div>
            </a>
          </li>

          <!-- Applications & Notifications -->
          <li (click)="toggleMenu()" class="menu-item" routerLinkActive="active">
            <a routerLink="/Admin/Applications" class="menu-link">
              <i class="menu-icon fa fa-file-alt"></i>
              <div>Bewerbungen</div>
            </a>
          </li>
            <!-- Courses -->
          <li (click)="toggleMenu()" class="menu-item" routerLinkActive="active">
            <a [routerLink]="['/Admin/Courses']" class="menu-link">
              <i class="menu-icon fas fa-graduation-cap"></i>
              <div>Kursbewerbungen</div>
            </a>
          </li>

          <!-- Articles & Content -->
          <li (click)="toggleMenu()" class="menu-item" routerLinkActive="active">
            <a routerLink="/Admin/Articles" class="menu-link">
              <i class="menu-icon fa fa-newspaper"></i>
              <div>Artikel</div>
            </a>
          </li>
          <!-- Articles & Content -->
          <li (click)="toggleMenu()" class="menu-item" routerLinkActive="active">
            <a routerLink="/Admin/Faqs" class="menu-link">
              <i class="menu-icon fa-solid fa-circle-question"></i>
              <div>FAQ</div>
            </a>
          </li>

          <!-- Announcements -->
          <li (click)="toggleMenu()" class="menu-item" routerLinkActive="active">
            <a routerLink="/Admin/Testimonial" class="menu-link">
              <i class="menu-icon fa fa-solid fa-quote-left"></i>
              <div>Erfahrungsberichte</div>
            </a>
          </li>
          <!-- Notification -->
          <li (click)="toggleMenu()" class="menu-item" routerLinkActive="active">
            <a routerLink="/Admin/Notifications" class="menu-link">
              <i class="menu-icon fa fa-bell"></i>
              <div>Benachrichtigungen</div>
            </a>
          </li>
          <!-- Messages -->
          <li (click)="toggleMenu()" class="menu-item" routerLinkActive="active">
            <a routerLink="/Admin/Messages" class="menu-link">
              <i class="menu-icon fa fa-comments"></i>
              <div>Nachrichten</div>
            </a>
          </li>

          <!-- Settings -->
          <li (click)="toggleMenu()" class="menu-item" routerLinkActive="active">
            <a routerLink="/Admin/Settings" class="menu-link">
              <i class="menu-icon fa fa-cogs"></i>
              <div>Einstellungen</div>
            </a>
          </li>

          <!-- Logout -->
          <li class="menu-item" (click)="logOut()">
            <a class="menu-link" style="cursor: pointer;">
              <i class="fa-solid fa-right-from-bracket"></i>
              <div>Abmelden</div>
            </a>
          </li>

        </ul>
      </aside>

      <!-- Main Page -->
      <div class="layout-page">
        <nav
            class="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
            id="layout-navbar"
          >
            <div (click)="toggleMenu()" #menuToggles class="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
              <a class="nav-item nav-link px-0 me-xl-4" href="javascript:void(0)">
                <i class="fa-solid fa-bars fa-sm"></i>
              </a>
            </div>

            <div class="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
              <!-- Search -->
              <div class="navbar-nav align-items-center">
                <div class="nav-item d-flex align-items-center">
                  <i class="bx bx-search fs-4 lh-0"></i>
                  <input
                    type="text"
                    class="form-control border-0 shadow-none"
                    placeholder="Suchen..."
                    aria-label="Suchen..."
                  />
                </div>
              </div>
              <!-- /Search -->

              <ul class="navbar-nav flex-row align-items-center ms-auto">
                <!-- Place this tag where you want the button to render. -->
                <li class="nav-item dropdown lh-1 me-3 notification" data-bs-auto-close="outside">
                  <a
                    class="nav-link dropdown-toggle position-relative"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="fa-solid fa-bell"></i>
                    <span class="nb">
                      {{notificationCount}}
                    </span>
                  </a>

                  <ul class="dropdown-menu dropdown-menu-end" style="width: 400px;">
                    <li><h6 class="dropdown-header">Benachrichtigungen</h6></li>
                    <li *ngFor="let notification of notifications" 
                        [class.unread]="notification.status === 'UNREAD'" 
                        class="p-3 m-3 rounded-2">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                          <div class="table-noti-icon">
                            <i [class]="sharedService.getNotificationIcon(notification.type)"></i>
                          </div>
                          <div class="table-noti-message ms-3">
                            <h6>
                              <a href="javascript:void(0);">{{ notification.title }}</a>
                            </h6>
                            <span class="message-time">{{ notification.timestamp.toDate() | date:'medium' }}</span>
                          </div>
                        </div>
                      </div>
                    </li>
                     <div class="alert alert-info" *ngIf="notifications.length == 0">
                      <i class="fa-solid fa-circle-info me-2"></i> Es gibt noch keine Benachrichtigungen
                    </div>
                    <li><hr class="dropdown-divider" *ngIf="notifications.length"></li>
                    <li *ngIf="notifications.length"><a class="dropdown-item text-center text-primary" [routerLink]="['/Admin/Notifications']" (click)="updateAllNotifications(userUid)">Alle anzeigen</a></li>
                  </ul>
                </li>

                <!-- User -->
                <li class="nav-item navbar-dropdown dropdown-user dropdown">
                  <a class="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown">
                    <div class="avatar avatar-online">
                      <img [src]="userInfo.image" alt="Benutzerbild" class="w-px-40 h-auto rounded-circle" />
                    </div>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <a class="dropdown-item" href="#">
                        <div class="d-flex">
                          <div class="flex-shrink-0 me-3">
                            <div class="avatar avatar-online">
                              <img [src]="userInfo.image" alt="Benutzerbild" class="w-px-40 h-auto rounded-circle" />
                            </div>
                          </div>
                          <div class="flex-grow-1">
                            <span class="fw-semibold d-block">{{userInfo.fullName}}</span>
                            <small class="text-muted">{{userInfo.email}}</small>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <div class="dropdown-divider"></div>
                    </li>
                    <li>
                      <a class="dropdown-item" routerLink="/Admin/Dashboard">
                        <i class="bx bx-user me-2"></i>
                        <span class="align-middle">Mein Profil</span>
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" routerLink="/Admin/Settings">
                        <i class="bx bx-cog me-2"></i>
                        <span class="align-middle">Einstellungen</span>
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" (click)="logOut()">
                        <i class="bx bx-power-off me-2"></i>
                        <span class="align-middle">Abmelden</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <!--/ User -->
              </ul>
            </div>
          </nav>
        <!-- Content -->
        <div class="content-wrapper">
          <div class="container-xxl flex-grow-1 container-p-y">
                <router-outlet></router-outlet> 
          </div>

          <!-- Footer -->
          <footer class="content-footer footer bg-footer-theme">
            <div class="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column">
              <div class="mb-2 mb-md-0">
                © <script>document.write(new Date().getFullYear());</script>, erstellt mit ❤️ von
                <a href="#" class="footer-link fw-bolder">Zakaria Yousfi & Wael Balhoudi</a>
              </div>
              <div>
                <a href="#" class="footer-link me-4">Lizenz</a>
                <a href="#" class="footer-link me-4">Weitere Themen</a>
                <a href="#" class="footer-link me-4">Dokumentation</a>
                <a href="#" class="footer-link me-4">Support</a>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
      <div class="layout-overlay layout-menu-toggle" (click)="toggleMenu()"></div>

  </div>
  <div *ngIf="showSpinner" class="d-flex align-items-center justify-content-center" style="height: 100vh;">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Lädt...</span>
    </div>
  </div>